export const defaultLanguage = 'en';
export const supportedLanguages = [defaultLanguage, 'ar'];
